// extracted by mini-css-extract-plugin
module.exports = {"lateralRightSwitch":"index_lateralRightSwitch___RKzX","readOnly":"index_readOnly__hFhLF"};